import React, { memo } from "react";

import type { BoxProps } from "./box.types";

import s from "./box.module.scss";

const Box = ({
  children,
  border,
  padding,
  margin,
  backgroundColor,
  borderRadius,
  gap,
  width,
  height,
  justifyContent,
  alignItems,
  ...props
}: BoxProps) => {
  const boxStyles = {
    padding,
    margin,
    border,
    backgroundColor,
    borderRadius,
    gap,
    width,
    height,
    justifyContent,
    alignItems
  };

  return (
    <div className={s.box} style={boxStyles} {...props}>
      {children}
    </div>
  );
};

export default memo(Box);
